<template>
   <div class="mb-3">
      <label>Search Screens</label>

      <c-input type="text" :value="filters.search" @input="updateSearch" />
    </div>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'

export default {
  mixins: [useQueryParamFilters()],

  data () {
    return {
      filters: {
        search: null
      },
    }
  },

  computed: {
    status: {
      get () {
        return this.statusOptions.find(({ value }) => value === this.filters.status)
      },

      set ({ value }) {
        this.filters.status = value
      }
    },
  },

  methods: {
    updateSearch: debounce(function (value) {
      this.filters.search = value
    }, 500)
  }
}
</script>
